import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { supabase } from '@/lib/supabase';

export default function MobileAuthCallback() {
  const [status, setStatus] = useState('Processing...');
  const [error, setError] = useState('');

  useEffect(() => {
    const processCallback = async () => {
      try {
        console.log('📱 Mobile auth callback triggered');
        
        // Get URL parameters
        const searchParams = new URLSearchParams(window.location.search);
        const accessToken = searchParams.get('access_token');
        const refreshToken = searchParams.get('refresh_token');
        const type = searchParams.get('type');
        const authError = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');
        
        console.log('🔑 Tokens received:', {
          hasAccessToken: !!accessToken,
          hasRefreshToken: !!refreshToken,
          type,
          error: authError
        });
        
        // Handle errors
        if (authError) {
          setError(errorDescription || authError);
          setStatus('Authentication failed');
          return;
        }
        
        // Process tokens
        if (accessToken && refreshToken) {
          setStatus('Redirecting to mobile app...');
          
          // Redirect to mobile app with tokens
          const mobileUrl = `flowscash://auth/callback?access_token=${encodeURIComponent(accessToken)}&refresh_token=${encodeURIComponent(refreshToken)}&type=${type || 'signup'}`;
          
          console.log('🔗 Redirecting to mobile app:', mobileUrl);
          
          // Try to open the mobile app
          window.location.href = mobileUrl;
          
          // Show success message
          setStatus('Opening mobile app...');
          
          // Fallback message after 3 seconds
          setTimeout(() => {
            setStatus('If the app didn\'t open automatically, please open the Flows.Cash app manually.');
          }, 3000);
          
        } else {
          // No tokens, process with Supabase session
          const { data, error: sessionError } = await supabase.auth.getSession();
          
          if (sessionError) {
            setError('Failed to get session: ' + sessionError.message);
            return;
          }
          
          if (data.session) {
            // We have a session, redirect with session tokens
            const mobileUrl = `flowscash://auth/callback?access_token=${encodeURIComponent(data.session.access_token)}&refresh_token=${encodeURIComponent(data.session.refresh_token)}&type=session`;
            
            console.log('🔗 Redirecting with session tokens:', mobileUrl);
            window.location.href = mobileUrl;
            setStatus('Opening mobile app...');
          } else {
            setError('No authentication session found');
          }
        }
        
      } catch (err: any) {
        console.error('❌ Mobile auth callback error:', err);
        setError(err.message);
        setStatus('Authentication failed');
      }
    };
    
    processCallback();
  }, []);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-auto p-6 text-center">
        <div className="mb-6">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <h1 className="text-xl font-semibold mb-2">Email Confirmation</h1>
          <p className="text-muted-foreground">{status}</p>
        </div>
        
        {error && (
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-4 text-destructive">
            <p className="font-medium">Error</p>
            <p className="text-sm mt-1">{error}</p>
            <p className="text-sm mt-2">Please try opening the Flows.Cash app manually.</p>
          </div>
        )}
        
        <div className="mt-6 text-sm text-muted-foreground">
          <p>This page will automatically redirect you to the Flows.Cash mobile app.</p>
          <p className="mt-2">If the app doesn't open, please open it manually to complete your email confirmation.</p>
        </div>
      </div>
    </div>
  );
} 